import styled from 'styled-components';
import {} from './index.js';
import { getMargins } from '@oneaudi/unified-web-alpha-common';
export const StyledSVG = styled.svg `
  color: inherit;
  margin: ${(props) => getMargins(props.margin)};
`;
//# sourceMappingURL=index.styles.js.map